<template>
    <div class="flex flex-col gap-4 rounded border border-gray-300 p-4">
        <div class="flex flex-row items-center" v-auto-animate>
            <div class="flex-1">
                {{$t('BULK_ITEM')}}{{index + 1}}
            </div>

            <button v-if="canRemove" class="flex-none border-none bg-transparent font-sans text-[12px] text-danger"
                @click.prevent="remove"
            >
                {{$t('BULK_REMOVE')}}
            </button>
        </div>

        <div>
            <text-entry v-if="item.type === 'text'"
                :controller="viewController"
                :selected-option="selectedOption"
                :value="item.text"
                :valid="item.valid"
                :just-added="item.justAdded"
                @input="updateText"
                @error="updateError"
            />

            <monogram-entry v-if="item.type === 'monogram'"
                :controller="viewController"
                :selected-option="selectedOption"
                :value="item.text"
                :valid="item.valid"
                :just-added="item.justAdded"
                @input="updateMonogram"
                @error="updateError"
            />
        </div>
    </div>
</template>

<script>
    import TextEntry from './TextEntry.vue';
    import MonogramEntry from './MonogramEntry.vue';

    import allStores from '../../stores/all';

    export default {
        mixins: [allStores],

        components: {
            TextEntry,
            MonogramEntry,
        },

        props: {
            item: Object,
            index: Number,
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            groupPersonalization() {
                return this.customizerStore.groupPersonalization;
            },

            canRemove() {
                return this.groupPersonalization?.length > 1;
            },

            selectedOption() {
                if (this.item.type === 'text') {
                    return this.viewController.selectedAtPlacement('Text');
                }

                if (this.item.type === 'monogram') {
                    return this.viewController.selectedAtPlacement('Monogram');
                }

                return null;
            },
        },

        methods: {
            updateText(updated) {
                // It is only fired if fully updated and validated.
                this.customizerStore.updateGroupPersonalization(this.item, updated.text);
            },

            updateMonogram(updated) {
                // It is only fired if fully updated and validated.
                this.customizerStore.updateGroupPersonalization(this.item, updated.text);
            },

            updateError() {
                this.customizerStore.setGroupPersonalizationError(this.item, true);
            },

            remove() {
                this.customizerStore.removeGroupItem(this.item);
            },
        },
    };
</script>
